import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCloudMoon",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), o("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--cloud-moon"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloud Moon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.98 6.558A2 2 0 1 0 3.5 10.5h3a1 1 0 0 0 0-2h-.55a.5.5 0 0 1-.49-.4 2 2 0 0 0-1.48-1.542Zm-1.43-.904A3 3 0 0 1 6.33 7.5h.17a2 2 0 1 1 0 4h-3a3 3 0 0 1-.95-5.846Zm4.466-2.952a2.5 2.5 0 0 0-1.482 1.881.5.5 0 1 1-.985-.166A3.501 3.501 0 0 1 7.999 1.5a.5.5 0 0 1 .36.849 1.622 1.622 0 0 0 2.292 2.293A.5.5 0 0 1 11.5 5a3.498 3.498 0 0 1-1.75 3.031.5.5 0 1 1-.5-.865c.466-.27.836-.685 1.05-1.183a2.621 2.621 0 0 1-3.284-3.281Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ s(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=cloud-moon.js.map
